<template>
  <div class="respace">
    <b-form-group
      label-for="input-statement"
      label-cols-sm="4"
      label-cols-lg="2"
      label="공통 지시문"
    >
      <b-form-input
        id="input-statement"
        v-model="statement"
        :class="statement_valid_cls"
      ></b-form-input>
    </b-form-group>

    <div>지문/보기.</div>
    <NormalEditor id="xxx1" ref="editor5" :content="jimun" func="updateJimun" />

    <div>해석</div>
    <NormalEditor  id="xxx2" ref="editor6" :content="translate" func="updateTranslate" />

    <div>해설</div>
    <NormalEditor id="xxx3" ref="editor7" :content="qcomment" func="updateQComment" />

    <!-- <div style="text-align: left; margin-bottom: 10px" v-if="meta_id != ''">
      <b-button
        @click="openDup()"
        size="sm"
        style="width: 100%"
        variant="danger"
        >중복문항 체크</b-button
      >
    </div> -->

    <div style="text-align: right">
      <b-button @click="metasave()" size="sm" variant="primary">{{
        metatext
      }}</b-button>
    </div>
    <hr />
    <QType1GroupList />
    <QType1GroupItemPicker />
    <QType1GroupItem />
    <SenReadingDup :main_metaid="idf" />
  </div>
</template>

<script>
import NormalEditor from "@/components/NormalEditor";

import QType1Answer from "@/components/question/QType1Answer";
import SenReadingDup from "@/components/question/SenReadingDup";
import QType1GroupItem from "@/components/question/QType1GroupItem";
import QType1GroupItemPicker from "@/components/question/QType1GroupItemPicker";

import QType1GroupList from "@/components/question/QType1GroupList";

export default {
  components: {
    NormalEditor,
    QType1GroupItem,
    QType1GroupList,
    QType1GroupItemPicker,
    SenReadingDup,
  },
  mounted() {
    // this.$store.commit("updateDebug", "그룹문항 마운트");
    //변경시 리셋코드
    if (this.$store.state.questionmeta.id == "") {
      this.$refs.editor5.reset();
      this.$refs.editor6.reset();
      this.$refs.editor7.reset();
    }
  },
  watch: {
    tabIndex(to, from) {
      this.$store.commit("updateDebug", "탭이 변경됨");
    },
    chapter(to, from) {
      if (to === "") {
        this.$refs.editor5.reset();
        this.$refs.editor6.reset();
        this.$refs.editor7.reset();
      }
    },
  },
  computed: {
    meta_id() {
      return this.$store.state.questionmeta.id;
    },

    std_type() {
      return this.$store.state.questionmeta.std_type;
    },
    chapter() {
      return this.$store.state.questionmeta.chapter;
    },

    statement_valid_cls() {
      return this.$store.state.valid.statement;
    },

    tabIndex() {
      return this.$store.state.tabIndex;
    },

    metatext() {
      return this.$store.state.questionmeta.id !== ""
        ? "메타 수정"
        : "메타 저장";
    },
    qtype1_answers() {
      return this.$store.state.qtype1_answers;
    },

    jimun() {
      return this.$store.state.questionmeta.jimun_imsi;
    },
    translate: {
      get() {
        return this.$store.state.questionmeta.translate_imsi;
      },
    },
    qcomment() {
      return this.$store.state.questionmeta.qcomment_imsi;
    },
    statement: {
      get() {
        return this.$store.state.questionmeta.statement;
      },
      set(val) {
        this.$store.commit("updateStatement", val);
      },
    },
    groupitems() {
      return this.$store.state.qforms;
    },
  },
  methods: {
    async metasave() {
      let _k = await this.$store.dispatch("saveorupdateQType1GroupMeta");

      if (!_k) {
        alert("폼을 확인해주세요");
        return false;
      }
      let msg = `${this.metatext}을 하였습니다.`;
      alert(msg);
    },
    openDup() {
      // this.formChapter = {};
      this.$nextTick(() => {
        this.$bvModal.show("myiddup");
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.respace {
  padding-top: 10px;
}
.invalid {
  border: 2px solid red;
}

.button_wrapper {
  button {
    margin-right: 5px;
  }
}
</style>
